var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormLogin',{ref:"formLogin",attrs:{"titleClass":"red"},on:{"login":_vm.login,"guest-login":_vm.guestOwnerLogin},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("OwnerLogin")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }